import type { StickySectionEntry } from '#/components/ui/StickySectionNav';
import type { ProductTypeSlug } from '#/types';

/**
 * Candidate section nav entries per product type, in page order. Sections drop
 * out when their data is missing, so SectionNav filters these down to the ones
 * that actually mounted; the loading skeleton renders every id.
 */
export const DETAIL_SECTION_NAV: Record<ProductTypeSlug, StickySectionEntry[]> =
  {
    equities: [
      { id: 'summary', label: 'Summary' },
      { id: 'performance', label: 'Performance' },
      { id: 'key-stats', label: 'Key Stats' },
      { id: 'price', label: 'Price' },
      { id: 'risk', label: 'Risk' },
      { id: 'filings', label: 'Filings' },
      { id: 'top-holders', label: 'Top Holdings' },
      { id: 'related', label: 'Related' },
      { id: 'learn-more', label: 'Learn More' },
    ],
    etfs: [
      { id: 'summary', label: 'Summary' },
      { id: 'performance', label: 'Performance' },
      { id: 'key-stats', label: 'Key Stats' },
      { id: 'price', label: 'Price' },
      { id: 'risk', label: 'Risk' },
      { id: 'portfolio', label: 'Portfolio' },
      { id: 'top-holdings', label: 'Top Holdings' },
      { id: 'related', label: 'Related' },
      { id: 'learn-more', label: 'Learn More' },
    ],
    'mutual-funds': [
      { id: 'summary', label: 'Summary' },
      { id: 'performance', label: 'Performance' },
      { id: 'key-stats', label: 'Key Stats' },
      { id: 'price', label: 'Price' },
      { id: 'risk', label: 'Risk' },
      { id: 'portfolio', label: 'Portfolio' },
      { id: 'top-holdings', label: 'Top Holdings' },
      { id: 'related', label: 'Related' },
      { id: 'learn-more', label: 'Learn More' },
    ],
  };
